module.exports = __webpack_public_path__ + "static/media/playerBG.b12fcb43.jpg";